// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/:app_id/feature_flags_eligibility/:user_id/:device_id" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppIdFeatureFlagsEligibilityUserIdDeviceId } from "./constants";
import type {
  EngagementAppIdFeatureFlagsEligibilityUserIdDeviceIdParams,
  EngagementAppIdFeatureFlagsEligibilityUserIdDeviceIdResult,
} from "./types";
import { isEngagementAppIdFeatureFlagsEligibilityUserIdDeviceIdResult } from "./validators";

export const getDataTableEngagementAppIdFeatureFlagsEligibilityUserIdDeviceId = reactQueryTableFetcherAdapter(
  engagementAppIdFeatureFlagsEligibilityUserIdDeviceId,
  (
    signal: AbortSignal,
    {
      appId,
      userId,
      deviceId,
      query = {},
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: EngagementAppIdFeatureFlagsEligibilityUserIdDeviceIdParams
  ): Promise<EngagementAppIdFeatureFlagsEligibilityUserIdDeviceIdResult> => {
    return fetch(
      `/engagement/${appId}/feature_flags_eligibility/${userId}/${deviceId}`,
      "GET",
      {
        limit,
        sortby,
        sortdir,
        start,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  },
  isEngagementAppIdFeatureFlagsEligibilityUserIdDeviceIdResult
);
